import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";  // Import Redux Provider
import App from "./App";
import "./index.css";
import store from "./store"; // Import your Redux store

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Wrap the App with Redux Provider */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
